import { Spinner } from '@frontend/authorization';
import { MultiObjectSelectInput } from '@frontend/components/basic-forms';
import { IoTClient } from '@frontend/iot/api';
import { IoT, IoTQueryParams } from '@frontend/iot/types';
import { useAccountRepository } from '@frontend/repository';
import React from 'react';

import useMultiIoTSelect, { MultiIoTSelectProps } from './multi-iot-select.controller';

const ID = 'multi-iot-select';

export const MultiIoTSelect = (props: MultiIoTSelectProps) => {
    const {
        store: { currentAccount }
    } = useAccountRepository();
    const viewProps = useMultiIoTSelect(props);

    if (!currentAccount) return <Spinner />;

    return (
        <MultiObjectSelectInput<IoT, IoTQueryParams>
            {...props}
            id={`${ID}${props.id ? '-' + props.id : ''}`}
            key={`${ID}${props.id ? '-' + props.id : ''}`}
            label={props.label || 'IoT'}
            className={props.className}
            onChange={(v) => {
                props.onChange && props.onChange(v.map((iot) => iot.id));
                props.onChangeObject && props.onChangeObject(v);
                viewProps.changeValue(v);
            }}
            value={props.value || viewProps.value?.map((iot) => iot.id) || []}
            multiFetch={(ids) => IoTClient.resolveIoTs(ids).then((res) => res.results)}
            fetch={(arg) => IoTClient.fetchIoTs({ ...arg, sort_field: 'name', sort_direction: 'asc' })}
            itemLabel={(iot) => iot.name}
            isClearable={props.isClearable}
            disabled={props.disabled}
            required={props.required}
            queryParams={props.queryParams}
            helpMessage={props.helpMessage}
        />
    );
};

export default MultiIoTSelect;
